import type { ApiMeta, ApiResponse } from "@/lib/n8n/contracts";

/**
 * Appels depuis le navigateur — toujours via le proxy `/api/n8n/…`,
 * jamais directement vers n8n : c'est le proxy qui détient le jeton.
 */

export class ApiError extends Error {
  constructor(readonly code: string, message: string) {
    super(message);
    this.name = "ApiError";
  }
}

export async function fetchN8n<T>(
  webhook: string,
  params: Record<string, string | number | undefined> = {},
): Promise<{ data: T; meta?: ApiMeta }> {
  const url = new URL(`/api/n8n/${webhook}`, window.location.origin);
  for (const [k, v] of Object.entries(params)) {
    if (v !== undefined && v !== "") url.searchParams.set(k, String(v));
  }

  const res = await fetch(url, { headers: { Accept: "application/json" } });
  const json = (await res.json().catch(() => null)) as ApiResponse<T> | null;

  if (!json) throw new ApiError("INTERNAL", "Réponse illisible du serveur.");
  if (!json.ok) throw new ApiError(json.error.code, json.error.message);
  return { data: json.data, meta: json.meta };
}

export async function postN8n<T>(webhook: string, body: unknown): Promise<T> {
  const res = await fetch(`/api/n8n/${webhook}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  const json = (await res.json().catch(() => null)) as ApiResponse<T> | null;

  if (!json) throw new ApiError("INTERNAL", "Réponse illisible du serveur.");
  if (!json.ok) throw new ApiError(json.error.code, json.error.message);
  return json.data;
}
